import { Stack, Typography } from "@mui/material";
import { DataType } from "csstype";
export type RowsElementProps = {
  rows: RowElement[];
  fontSizeDefault?: string;
  top: string;
  left: string;
  width: string;
  height?: string;
  elementSpacing?: string;
  lineHeight?: string;
};
export const RowsElement = ({
  rows,
  fontSizeDefault,
  top,
  left,
  width,
  elementSpacing,
  lineHeight,
  height,
}: RowsElementProps) => {
  return (
    <Stack
      sx={{
        top: top,
        left: left,
        position: "absolute",
        zIndex: "10",
        width: width,
        maxWidth: width,
        height: height,
        maxHeight: height,
        backgroundColor:
          process.env.NODE_ENV === "development"
            ? "rgba(21, 227, 223, 0.2)"
            : undefined,
      }}
    >
      {rows.map((x, idx) => (
        <Stack sx={{ width: "100%" }} direction={"row"} key={idx}>
          {x.elements.map((x) => {
            if (!x.fontSize) {
              x.fontSize = fontSizeDefault || "inherit";
            }
            return (
              <Typography
                key={x.name}
                sx={{
                  width: x.width,
                  fontSize: x.fontSize,
                  lineHeight: lineHeight,
                  marginLeft: elementSpacing,
                  overflowWrap: "break-word",
                  alignSelf: x.textAlign ? x.textAlign : "auto",
                  backgroundColor:
                    process.env.NODE_ENV === "development"
                      ? "rgba(38, 237, 73, 0.2)"
                      : undefined,
                }}
              >
                {x.value}
              </Typography>
            );
          })}
        </Stack>
      ))}
    </Stack>
  );
};

export type RowElement = {
  elements: RowItemElement[];
};

export type RowItemElement = {
  name: string;
  value: string;
  fontSize?: string;
  height?: string;
  width?: string;
  textAlign?: DataType.SelfPosition;
};
